import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveIcon from '@material-ui/icons/Remove';
import CloseIcon from '@material-ui/icons/Close';
import SharedAdminDrawer, { DRAWER_WIDTH_XL, DRAWER_WIDTH_LG, DRAWER_WIDTH_MD, DRAWER_WIDTH_SM } from '../SharedAdminDrawer';
import { useSelector } from 'react-redux';
import SharedAppBar from '../SharedAppBar';
import Auth from '../../../Landingpagecomponents/Header/auth';
import { withRouter, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import useClinicianAuthGuard from '../useClinicianAuthGuard';
import moment from 'moment';
import { Avatar, Card, CardActions, CardContent } from '@material-ui/core';
import EHRBookingCalendar from '../Calendar/components/calendarClinic';
import ClinicSubscription_Settings from '../clinicSubscription_Settings';
import HealingIcon from '@material-ui/icons/Healing';
import { ChatSystemContainer } from '../../../components/ChatSystem';
import VideoCallLauncherDialog from '../VideoCallLauncherDialog';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  avatar: {
    backgroundColor: '#00e676',
    height: 50,
    width: 50,
  },
  toolbar: {
    paddingRight: 24,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 57,
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    [theme.breakpoints.down('xs')]: {
      height: 50,
    },
    [theme.breakpoints.up('sm')]: {
      height: 57,
    },
    [theme.breakpoints.up('md')]: {
      height: 57,
    },
  },
  responsiveLogo: {
    marginTop: 5,
    maxWidth: 200,
    minWidth: 165,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 120,
      minWidth: 165,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 180,
      minWidth: 165,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 190,
      minWidth: 165,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 190,
      minWidth: 165,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 190,
      minWidth: 165,
    },
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(0),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    borderRadius: 18
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Clinic_calendar() {
  const { isAuthorizedClinician } = useClinicianAuthGuard();
  const token = useSelector((state) => state.auth.token);
  const [webcamDialogOpen, setWebcamDialogOpen] = useState(false);
  const handleOpenWebcamDialog = () => setWebcamDialogOpen(true);
  const handleCloseWebcamDialog = () => setWebcamDialogOpen(false);

  const classes = useStyles();
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const activeDrawerWidth = isSm ? DRAWER_WIDTH_SM : isMd ? DRAWER_WIDTH_MD : isXl ? DRAWER_WIDTH_XL : DRAWER_WIDTH_LG;
  const [open, setOpen] = useState(true);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const Profile = ({ className, ...rest }) => {
    const classes = useStyles();

    return (
      <Card className={classes.root}>
      </Card>
    );
  };

  Profile.propTypes = {
    className: PropTypes.string,
  };

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  if (!isAuthorizedClinician || !token) {
    return <div>Redirecting...</div>;
  }

  return (
    <div className={`${classes.root} admin-dash`}>
      <CssBaseline />
      {/* <SharedAppBar
        open={open}
        drawerWidth={activeDrawerWidth}
        showMessages={true}
        showVideocall={true}
        onVideocallClick={handleOpenWebcamDialog}
      /> */}
      <VideoCallLauncherDialog open={webcamDialogOpen} onClose={handleCloseWebcamDialog} authToken={token} />
      <SharedAdminDrawer open={open} onOpen={handleDrawerOpen} onClose={handleDrawerClose} onVideocallClick={handleOpenWebcamDialog} />
      <main className={classes.content} style={{ background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)' }}>
        {/* <div className={classes.appBarSpacer} /> */}
        <Grid maxWidth="100%" className={classes.container}>
          <Grid item xs={12}>
            <Paper className={classes.paper} style={{ marginBottom: 0 }}>
              <EHRBookingCalendar />
            </Paper>
          </Grid>
          <Box pt={2}>
            <Copyright />
          </Box>
        </Grid>
        <ChatSystemContainer />
      </main>
    </div>
  );
}
